import * as TypesUser from '../types/types_user';
import Vue from 'vue';

// 这个方案比 _.cloneDeep()效率高；
const getDefaultState = () => {
    return {
        profile: {},
        communicationInfo: { checkBind: false },
        imgConfig: {}
        // username: ''
    };
};

export default {
    state: getDefaultState(),
    mutations: {
        [TypesUser.USER_SET_PROFILE](state, payload) {
            state.profile = payload || {};
        },
        // 保存用户账号，涨价提示时要用
        // [TypesUser.USER_SAVE_USERNAME](state, username) {
        //     console.log(username, 'username');
        //     state.username = username || '';
        // },
        [TypesUser.USER_SET_COMMUNICATION](state, payload) {
            if (payload) {
                state.communicationInfo = Object.assign({}, payload, { checkBind: true });
            } else {
                state.communicationInfo = { checkBind: false };
            }
        },
        [TypesUser.USER_SET_IMG_CONFIG](state, payload) {
            state.imgConfig = payload || {};
        },
        [TypesUser.USER_RESET_STATE](state) {
            let newState = getDefaultState();
            // 为保留响应式，需要这么处理：
            Object.keys(newState).forEach(key => {
                state[key] = newState[key];
            });
        }
    },
    actions: {
        // 获取图片验证码
        [TypesUser.USER_GET_CAPTCHA](ctx, { captchaId }) {
            return Vue.axios({ baseURL: `${feConfig.api.captcha}` }).post('/captcha', {
                apiKey: 'hfs',
                captchaId
            }).then(resp => {
                return Vue.checkResp(resp);
            }).then(data => {
                return data;
            }).catch(err => {
                throw err;
            });
        },
        // 验证图片验证码
        [TypesUser.USER_VERIFY_CAPTCHA](ctx, { captchaId, inputText }) {
            return Vue.axios({ baseURL: `${feConfig.api.captcha}` }).get('/captcha/match-result', {
                params: { apiKey: 'hfs', captchaId, inputText }
            }).then(resp => {
                return Vue.checkResp(resp);
            }).then(data => {
                return data;
            }).catch(err => {
                throw err;
            });
        },
        // ---------------------------------------------
        // 报名
        [TypesUser.USER_POST_SIGNUP](ctx, { name, phoneNumber, grade, subject }) {
            return Vue.http.post('/v1/appointments', {
                flag: 'hfsfd-ow',
                name,
                phone: phoneNumber,
                grade,
                subject,
                pageFlag: '官网报名'
            }).then(resp => {
                if (resp.code === 0) {
                    return {
                        success: true
                    };
                } else if (resp.code === 1004 || resp.code === 3101) {
                    return {
                        hasSignUp: true
                    };
                } else {
                    return Promise.reject({
                        code: resp.code,
                        msg: resp.msg
                    });
                }
            });
        },
        // 登录
        [TypesUser.USER_POST_LOGIN](ctx, { username, password, userType, deviceType, reCaptcha, captchaId }) {
            return Vue.http.post('/v2/users/sessions', {
                username,
                password,
                userType,
                deviceType,
                reCaptcha,
                captchaId
            }).then(resp => {
                return Vue.checkResp(resp);
            }).then(data => {
                ctx.commit(TypesUser.USER_SET_PROFILE, data);
                // ctx.commit(TypesUser.USER_SAVE_USERNAME, username);
                return data;
            }).catch(err => {
                ctx.commit(TypesUser.USER_SET_PROFILE, null);
                throw err;
            });
        },
        // 获取用户基本信息
        [TypesUser.USER_GET_PROFILE](ctx) {
            return Vue.http.get('/v1/user-center/basic-info').then(resp => {
                return Vue.checkResp(resp);
            }).then(data => {
                ctx.commit(TypesUser.USER_SET_PROFILE, data);
                return data;
            }).catch(err => {
                ctx.commit(TypesUser.USER_SET_PROFILE, null);
                throw err;
            });
        },
        // 填写用户基本信息
        [TypesUser.USER_SET_BASICINFO](ctx, { avatar, name, sex, grade, locale, schoolName }) {
            return Vue.http.post('/v1/user-center/basic-info', { avatar, name, sex, grade, locale, schoolName }).then(resp => {
                return Vue.checkResp(resp);
            }).then(data => {
                return data;
            }).catch(err => {
                throw err;
            });
        },
        // 获取账号通讯信息
        [TypesUser.USER_GET_COMMUNICATION](ctx) {
            return Vue.http.get('/v1/user-center/communication-info').then(resp => {
                return Vue.checkResp(resp);
            }).then(data => {
                ctx.commit(TypesUser.USER_SET_COMMUNICATION, data);
                return data;
            }).catch(err => {
                ctx.commit(TypesUser.USER_SET_COMMUNICATION, null);
                throw err;
            });
        },
        // 退出
        [TypesUser.USER_DELETE_LOGOUT](ctx) {
            return Vue.http.delete('/v1/users/sessions').then(resp => {
                return Vue.checkResp(resp);
            }).then(data => {
                ctx.commit(TypesUser.USER_SET_PROFILE, null);
                return data;
            }).catch(err => {
                ctx.commit(TypesUser.USER_SET_PROFILE, null);
                throw err;
            });
        },
        // 获取上传图片配置信息
        [TypesUser.USER_GET_IMG_CONFIG](ctx) {
            return Vue.axios({ baseURL: `${feConfig.api.base}`, withCredentials: true })
                .get('/v1/config/ks3/authorization/post-policy').then(resp => {
                    return Vue.checkResp(resp);
                }).then(config => {
                    ctx.commit(TypesUser.USER_SET_IMG_CONFIG, config);
                    return config;
                }).catch(err => {
                    ctx.commit(TypesUser.USER_SET_IMG_CONFIG, null);
                    throw err;
                });
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/index/store/modules/modules_user.js